import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import moment from "moment";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useNewsDocumentDetails } from "./News.hook";
import { fields, fieldsReady } from "./constants";

export const AddEditCorporateNews = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [fieldData, setFieldData] = useState<any>();

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    await fieldsReady;
    setFieldData(fields);
  }

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useNewsDocumentDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      published: dataById ? decodeHTML(dataById.payload?.published) : editData ? decodeHTML(editData?.published) : false,
      field_news_title_en: dataById
        ? decodeHTML(dataById.payload.field_news_title_en)
        : editData
          ? decodeHTML(editData?.field_news_title_en)
          : "",
      field_news_title_ms: dataById
        ? decodeHTML(dataById.payload.field_news_title_ms)
        : editData
          ? decodeHTML(editData.field_news_title_ms)
          : "",
      field_news_title_zh: dataById
        ? decodeHTML(dataById.payload.field_news_title_zh)
        : editData
          ? decodeHTML(editData?.field_news_title_zh)
          : "",
      field_news_description_en: dataById
        ? decodeHTML(dataById.payload.field_news_description_en)
        : editData
          ? decodeHTML(editData?.field_news_description_en)
          : "",
      field_news_description_ms: dataById
        ? decodeHTML(dataById.payload.field_news_description_ms)
        : editData
          ? decodeHTML(editData.field_news_description_ms)
          : "",
      field_news_description_zh: dataById
        ? decodeHTML(dataById.payload.field_news_description_zh)
        : editData
          ? decodeHTML(editData?.field_news_description_zh)
          : "",
      // item_count: dataById
      //     ? dataById.payload.item_count
      //     : editData
      //     ? editData?.item_count
      //     : "",
      field_news_date:
        dataById?.payload && dataById?.payload?.field_news_date
          ? dataById?.payload?.field_news_date
          : editData?.field_news_date
            ? editData?.field_news_date
            : "",
      field_news_images: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_news_images.png",
              status: "done",
              url: dataById?.payload?.field_news_images,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_news_images.png",
              status: "done",
              url: editData?.field_news_images,
            },
          ]),
    },
    fields: fieldData?.news,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["field_news_images"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    // let dateKeys: any = ["date"];
    // for (const key of dateKeys) {
    //   if (data[key]) {
    //     data[key] = moment(data[key]).format("DD MMM YYYY");
    //   }
    // }

    const payload = {
      action: action,
      method: method,
      module: "Media Center",
      subModule: "news_newsPageContent",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      moduleKey: "MAHB_CORPORATE_Media Center_News",
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        title: data?.field_news_title_en ?? "",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add"} News`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${corporateHost}/api/newscard/${editData?.id || dataById?.payload?.id}` : `${corporateHost}/api/create/newscard`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Media Center"
      />
    </ContentWrapper>
  );
};
